import { useSearchParams, useRoute } from "@softmax/web-features/navigation";

import { useEffect } from "react";

// Identity workflows preserve the page that opened account settings.
export const accountFromKey = "account:from";

export function AccountEntry() {
  const route = useRoute();
  const { pathname, name } = route;
  const search = useSearchParams().toString();
  useEffect(() => {
    if (
      [
        "account",
        "accountAdvanced",
        "accountCredentials",
        "signIn",
        "completeProfile",
        "githubConnect",
        "cliAuth",
        "cliAuthComplete",
      ].includes(name)
    )
      return;

    sessionStorage.setItem(
      accountFromKey,
      search ? `${pathname}?${search}` : pathname,
    );
  }, [pathname, name, search]);
  return null;
}
